// Configuration de l'URL de l'API
// En production (Vercel), utiliser l'URL Railway si REACT_APP_API_URL n'est pas défini
// IMPORTANT: pas de slash final, pas de double slash (...app//api/...)
const RAW_DEFAULT = process.env.NODE_ENV === 'production'
  ? 'https://steadfast-adaptation-production.up.railway.app'
  : 'http://localhost:8000';

// Normaliser l'URL : supprimer slash final, espaces, et doubles slashes (sauf ://)
function normalizeBaseUrl(url) {
  if (typeof url !== 'string' || !url) return RAW_DEFAULT;
  return url
    .trim()
    .replace(/\/+$/, '') // Supprimer slash final
    .replace(/([^:])\/\/+/g, '$1/') // Supprimer doubles slashes (sauf après ://)
    || RAW_DEFAULT;
}

const raw = process.env.REACT_APP_API_URL || RAW_DEFAULT;
const API_URL = normalizeBaseUrl(raw);

/** Supprime les doubles slashes (sauf après ://). */
function normalizeUrl(url) {
  if (typeof url !== 'string' || !url) return url;
  return url.replace(/([^:])\/\/+/g, '$1/');
}

/** Construit une URL API sans double slash (base + /api/xxx). */
export function apiPath(path) {
  const base = API_URL.replace(/\/+$/, '');
  const p = (path || '').replace(/^\/+/, '');
  const u = p ? `${base}/${p}` : base;
  return normalizeUrl(u);
}

/** Infos debug pour diagnostic 404 / CORS. */
export function getApiDebugInfo() {
  return {
    API_URL,
    REACT_APP_API_URL: process.env.REACT_APP_API_URL ?? '(non défini)',
    NODE_ENV: process.env.NODE_ENV,
    tokenUrl: apiPath('api/token/'),
    healthUrl: apiPath('api/health/'),
  };
}

export default API_URL;
